<template>
  <div class="rate">
    <!-- <span>
      {{ $t('_rate')}}
    </span> -->
    <span>
      {{ formatDecimal(value) }} /10
    </span>
  </div>
</template>

<script>
import formatter from '@/components/global/mixins/formatterMethods'
export default {
  mixins: [formatter],
  props: {
    value: {
      type: Number,
      required: true
    }
  }
}
</script>
